// modules/inicio/hooks/useSync.js
// Hook compartido de estado de conexión, usado por el Home, el MainLayout
// (badge "En línea"/"Sin conexión") y por cualquier módulo de estrategia que
// necesite saber si puede o no depender del backend en este momento.
//
// A medida que se implemente la sincronización real de la cola offline
// (Dexie, ver src/offline/db.js), este archivo es el lugar natural para
// agregar también el loop de sync y el conteo de pendientes/errores —
// igual que EstadoSincronizacion<Modulo>.jsx en el SI-PIC.

import { useEffect, useState } from "react";

export function useOnlineStatus() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const marcarOnline = () => setOnline(true);
    const marcarOffline = () => setOnline(false);

    window.addEventListener("online", marcarOnline);
    window.addEventListener("offline", marcarOffline);

    return () => {
      window.removeEventListener("online", marcarOnline);
      window.removeEventListener("offline", marcarOffline);
    };
  }, []);

  return online;
}